module.exports = __webpack_public_path__ + "static/img/empty_state_none@2x.32a0b9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/empty_state_none@2x.png
// module id = O/w/
// module chunks = 1